import { queryOptions, useQuery } from "@tanstack/react-query"

import type { PortalAuthMe } from "@optimist/schemas"
import { api } from "@/lib/api"

export const portalAuthQueryOptions = queryOptions({
	queryKey: ["auth", "me"],
	queryFn: () => api.get<PortalAuthMe>("/auth/me"),
})

export function usePortalAuth() {
	return useQuery(portalAuthQueryOptions)
}
